import { render, staticRenderFns } from "./app-loader.component.vue?vue&type=template&id=3877aa3e&"
import script from "./app-loader.component.ts?vue&type=script&lang=ts&"
export * from "./app-loader.component.ts?vue&type=script&lang=ts&"
import style0 from "./app-loader.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports